import { connect } from "react-redux";

import Waermerueckgewinnung from "./Waermerueckgewinnung";

import { compressorIsInstalled } from "../model/Kompressor";

const format_think_green_to_wrg = (think_green, parameters, compressors, units) => {
	if (think_green.compressors === undefined)
		return [];
		
	let report_hours = (think_green.time_of_last_update - think_green.time_of_first_update) / 3600;	// sehr elegant: [s] -> [h]
	let c_filtered = think_green.compressors.filter((c, i) => compressorIsInstalled(compressors[i]));
	let comp_ready = c_filtered.map(
		c => {
			let waerme = (c.energy_offload + c.energy_onload) * (parameters.rueckfuehrungsIndex === 1 ? 0.94 : 0.72);	// 0 -> Ölkreislauf, 1 -> Kanalsystem
			let waerme_avg = waerme / report_hours;
			let waerme_nutzbar = waerme * parameters.nutzungszeitraumWRG_percent;
			let erwaermtes_wasser = waerme_nutzbar / ((parameters.warmesWasserAus_degC - parameters.kaltesWasserEin_degC) * 4.187) * 3600 / 1000;
			let eingespartes_heizmaterial = waerme_nutzbar /
				(parameters.heizmaterialIndex === 1 ? units.gas_heating_value : units.oil_heating_value) /
				parameters.heizungWirkungsgrad_percent;
			let eingesparte_heizkosten = eingespartes_heizmaterial *
				(parameters.heizmaterialIndex === 1 ? units.gas_price : units.oil_price);
			let eingespartes_co2 = eingespartes_heizmaterial * 
				(parameters.heizmaterialIndex === 1 ? units.gas_co2_equivalent : units.oil_co2_equivalent);
			return {
				cindex: c.cindex,
				waerme_avg,
				waerme_nutzbar,
				erwaermtes_wasser,
				eingespartes_heizmaterial,
				eingesparte_heizkosten,
				eingespartes_co2
			};
		}
	);
	return comp_ready;
};

export default connect(state => {
	let wrg = format_think_green_to_wrg(
		state.ablauf.statistics.think_green,
		state.think_green.waermerueckgewinnung.parameter,
		state.ablauf.compressors,
		state.settings.units
	);
	return {
		wrg,
		compressors: state.ablauf.compressors,
		units: state.units,
		unit_heating_material: (state.think_green.waermerueckgewinnung.parameter.heizmaterialIndex === 1) ? "m3" : "l"
	};
})(Waermerueckgewinnung);
